import listening from "./../assets/images/listeningYAS.svg";
import moozik from "./../assets/images/moozik.svg";
import screenShotMultipleFilterBlueTintShort from "./../assets/images/screenShotMultipleFilterBlueTintShortYAS.png";
import Header from "../components/Header";
import ReactCodeInput from "react-code-input";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MoozikServices from "../services/http/MoozikServices";
import { useMsisdnContext } from "../context/MsisdnContext";
import { MoonLoader } from "react-spinners";
import Modal from "react-modal";
import MODAL_STYLES from "./../assets/styles/modal";
import closeYellow from "./../assets/images/closeYellow.svg";

const pinLength = 4;
const maxAttempts = 3;

const Verification = () => {
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [canSubmit, setCanSubmit] = useState(false);

  const { setOtp_ } = useMsisdnContext();
  const navigate = useNavigate();
  const { state } = useLocation();

  const [isModalFailed, setIsModalFailed] = useState(false);
  const [attemptsLeft, setAttemptsLeft] = useState(maxAttempts);
  const [modalMessage, setModalMessage] = useState("");

  function closeModal() {
    setIsModalFailed(false);
  }

  const handleVerification = useCallback(async () => {
    if (!loading) {
      if (canSubmit) {
        setLoading(true);
        try {
          setOtp_(otp);
          const identify = await MoozikServices.verifyOTP({
            rpid: state?.rpid,
            msisdn: state.msisdn,
            otp,
          });
          if (identify?.statuscode !== 200) {
            console.log("====================================");
            console.log("[!] erreur identification");
            console.log("====================================");
            setAttemptsLeft((prev) => prev - 1);
            if (attemptsLeft - 1 > 0) {
              setModalMessage(`Le code de vérification est incorrecte, Il vous reste ${attemptsLeft - 1} tentative(s)`);
            } else {
              setModalMessage(`Oops! Vous avez atteint le nombre maximal de tentatives`);
            }
            setIsModalFailed(true);
          }else{
            navigate("/payment", {
              state: {
                ...state,
                otp,
              },
            });
          }
        } catch (error) {
          setAttemptsLeft((prev) => prev - 1);
          if (attemptsLeft - 1 > 0) {
            setModalMessage(`Le code de vérification est incorrecte, Il vous reste ${attemptsLeft - 1} tentative(s)`);
          } else {
            setModalMessage(`Oops! Vous avez atteint le nombre maximal de tentatives`);
          }
          setIsModalFailed(true);
          console.log("error", JSON.stringify(error, null, 3));
          console.log("error", error);
        } finally {
          setLoading(false);
          // navigate("/payment", {
          //   state: {
          //     ...state,
          //     otp,
          //   },
          // });
        }
      }
    }
  }, [canSubmit, loading, navigate, otp, setOtp_, state, attemptsLeft]);

  // verif param navigation
  useEffect(() => {
    if (!state) {
      navigate("/");
    } else if (
      state &&
      (!state.rpid || !state.offername || !state.amount || !state.msisdn)
    ) {
      navigate("/");
    }
  }, [navigate, state]);

  // validation numéro telma
  useEffect(() => {
    setCanSubmit(otp.length === pinLength && /^\d+$/.test(otp));
  }, [otp]);

  useEffect(() => {
    if (attemptsLeft === 0 && !isModalFailed) {
      navigate("/");
    }
  }, [attemptsLeft, isModalFailed, navigate]);

  return (
    <div className="min-h-screen flex justify-center">
      <div className="max-w-[641px] w-full bg-[#00377D] h-auto overflow-visible text-left text-base text-white font-montserrat">
        <Header hideMsisdn />
        <div className="relative top-[20px] left-[0px] w-[100%] h-[fit-content] [background:#123274]">
          <img
            className="relative top-[-55px] w-[100%] object-contain"
            alt=""
            id="image_"
            src={listening}
          />
          <img
            className="relative top-[0px] w-[100%] object-cover"
            alt=""
            src={screenShotMultipleFilterBlueTintShort}
          />
          <div className="absolute top-[15%] left-[5%] right-[5%] w-auto z-5">
            <img
              className="relative w-[102px] h-[102px] object-cover"
              alt=""
              src={moozik}
            />

            <div className="relative text-[33px] mt-20 mb-7 leading-[42px] uppercase font-[700] text-whitesmoke-200">
              <p className="m-0 z-10">{`VERIFICATION`}</p>
              <p className="m-0 z-10">{`CODE OTP`}</p>
            </div>
            <div className="relative z-5 w-auto flex items-center flex-col">
              <div className="h-[45px] flex items-center flex-row justify-between">
                <ReactCodeInput
                  type="number"
                  fields={pinLength}
                  inputStyle={{
                    fontFamily: "Montserrat",
                    margin: "10px",
                    MozAppearance: "textfield",
                    width: "25px",
                    height: "45px",
                    borderRadius: "3px",
                    fontSize: "14px",
                    paddingLeft: "20px",
                    backgroundColor: "#123274",
                    color: "white",
                    border: "1px solid white",
                  }}
                  onChange={setOtp}
                  autoFocus
                />
              </div>
              <div
                onClick={handleVerification}
                className={`cursor-pointer w-[80%] h-[45px] rounded-[30px] flex items-center flex-row px-4 justify-center mt-8 uppercase text-black font-[700] bg-gold-200 [color:#00377D] ${
                  !canSubmit && "bg-slate-500"
                }`}
              >
                {!loading ? "VERIFIER" : <MoonLoader size={20} color="black" />}
              </div>
            </div>
          </div>
        </div>
        <div className="text-center relative bottom-10 left-0 right-0 text-white text-[10px] z-10">{`Copyright DIGITAL TELMA 2024`}</div>
      </div>

      <Modal
        isOpen={isModalFailed}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        style={MODAL_STYLES}
        contentLabel="Failed payment"
        className="moozik-modal"
      >
        <img
          className="relative top-[-15px] left-[95%] w-6 h-6"
          alt=""
          src={closeYellow}
          onClick={closeModal}
        />

        <div className="relative top-[-15px] w-[auto] ml-4 mr-4 container font-montserrat">
          <div className="flex items-center justify-center">
            <b className="text-5xl leading-[135%] text-red">
              Echec d'opération
            </b>
          </div>
          <div className="flex flex-col items-center justify-center mt-6">
            <div className="ml-2">
              {modalMessage}
            </div>
          </div>
          <div className="flex items-center justify-center mt-6">
            <div
              className="rounded-xl bg-mainblue w-[50%] h-10 flex items-center justify-center cursor-pointer"
              onClick={closeModal}
            >
              <div className="font-semibold text-gray-100">Fermer</div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-[10px] left-[0px] w-[100%] text-white text-3xs font-semibold opacity-[0.29] font-montserrat flex items-center justify-center">
          <span>Copyright DIGITAL TELMA 2023</span>
        </div>
      </Modal>
    </div>
  );
};

export default Verification;
